var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50001 3C3.67158 3 3 3.67158 3 4.50001V14.2826C3 15.1111 3.67158 15.7826 4.50001 15.7826H6.45653C7.00882 15.7826 7.45653 16.2304 7.45653 16.7826V19.5858L10.9668 16.0755C11.1544 15.888 11.4087 15.7826 11.6739 15.7826H19.5C20.3285 15.7826 21 15.1111 21 14.2826V4.50001C21 3.67158 20.3285 3 19.5 3H4.50001ZM1 4.50001C1 2.56701 2.56701 1 4.50001 1H19.5C21.433 1 23 2.56701 23 4.50001V14.2826C23 16.2156 21.433 17.7826 19.5 17.7826H12.0881L7.16364 22.7072C6.87764 22.9932 6.44752 23.0787 6.07385 22.9239C5.70017 22.7691 5.45653 22.4045 5.45653 22V17.7826H4.50001C2.56701 17.7826 1 16.2156 1 14.2826V4.50001ZM16.4571 6.2929C16.8477 6.68343 16.8477 7.31659 16.4571 7.70712L12.0821 12.0821C11.6916 12.4727 11.0584 12.4727 10.6679 12.0821L8.79291 10.2071C8.40239 9.8166 8.40239 9.18343 8.79291 8.79291C9.18343 8.40239 9.8166 8.40239 10.2071 8.79291L11.375 9.96081L15.0429 6.2929C15.4334 5.90238 16.0666 5.90238 16.4571 6.2929Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.2131bc8e07ec1328666ed739f2df5fef.svg";
export { ForwardRef as ReactComponent };